<template>
  <div class="containerTable" style="padding: 15px;">
    <vxe-toolbar
      id="toolbarId_fa8"
      :custom="{ storage: true }"
      export
      :buttons="toolbarButtons"
      :refresh="{ query: RefreshList }"
    />
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :footer-method="footerMethod"
      :loading="loading"
      :data="tableData"
    >
      <vxe-table-column type="index" title="序号" width="60" />
      <vxe-table-column>
        <vxe-table-column
          field="reviewer"
          title="运输单号"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="交易日期"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="reviewer"
          title="发货方全称"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="地址"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="统一社会信用代码"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="货物大类"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="交易金额"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="运输费用支付方式"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="支付渠道应收"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="开具发票的代码和号码"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="地址"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="卸货联系人身份证号码"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="货物起运地"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="到达地"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="起运时间"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="到达时间"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="运输里程"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="运输费用"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="支付方式"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="支付渠道"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="应支付金额"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="应纳税款"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="已纳税款"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="已向国税机关申请代开的发票代码和发票号码"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.page"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.limit"
      :total="listQuery.totalzong"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
import { fetchList } from "@/api/article";

export default {
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      listQuery: {
        page: 1,
        limit: 20,
        totalzong: 0
      },
      Pagingconf: [],
      toolbarButtons: [
        {
          code: "btn1",
          name: "查询"
        },
        {
          name: "下拉按钮",
          dropdowns: [
            {
              name: "按钮111",
              code: "btn2"
            },
            {
              name: "按钮222",
              code: "btn3"
            }
          ]
        }
      ]
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      fetchList(this.listQuery).then(response => {
        this.tableData = response.data.items;
        this.listQuery.totalzong = response.data.total;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
        this.loading = false;
      });
    },

    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.page = currentPage;
      this.listQuery.limit = pageSize;
      this.findList();
    } /* 
    footerCellClassName({ $rowIndex, column, columnIndex }) {
      if (columnIndex === 0) {
        if ($rowIndex === 0) {
          return 'col-blue'
        } else {
          return 'col-red'
        }
      }
    }, */,
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "平均";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.mean(data, column.property);
          }
          return null;
        }),
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "和值";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property);
          }
          return null;
        })
      ];
    }
  }
};
</script>

<style></style>
